module.exports = __webpack_public_path__ + "media/images/emblems/Missy-coat_of_arms-a0eadb943f385bf2310251ccd841e367.svg";